var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('StreamPlaybackCanvas',{attrs:{"source":_vm.videoSource,"title":_vm.userStore.email}})],1),_c('v-row',[_c('StreamDownloadButton',{attrs:{"stream":_vm.stream}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }